// ============================================
// ゲーム基本状態管理
// ============================================

import type { GameState, ShipType, Difficulty, GalleryCategory } from '../types/game-types';

// --- 基本ゲーム状態 ---
let _gameState: GameState = 'start';
let _selectedShip: ShipType = 'bomber';
let _selectedDifficulty: Difficulty = 'normal';

// --- ギャラリーモード用変数 ---
let _galleryCategory: GalleryCategory = 'ships';
let _galleryIndex: number = 0;
let _galleryStartTime: number = 0;
let _galleryLoadingTimer: number = 0;
let _galleryShipPage: number = 0;

// --- タイトル画面用変数 ---
let _titleTimer: number = 0;

// --- フレームレート非依存処理用 ---
let _dt: number = 1;
export const TARGET_FPS: number = 60;

// ============================================
// Getters and Setters
// ============================================

export const getGameState = (): GameState => _gameState;
export const setGameState = (val: GameState): void => {
    _gameState = val;
};

export const getSelectedShip = (): ShipType => _selectedShip;
export const setSelectedShip = (val: ShipType): void => {
    _selectedShip = val;
};

export const getSelectedDifficulty = (): Difficulty => _selectedDifficulty;
export const setSelectedDifficulty = (val: Difficulty): void => {
    _selectedDifficulty = val;
};

export const getGalleryCategory = (): GalleryCategory => _galleryCategory;
export const setGalleryCategory = (val: GalleryCategory): void => {
    _galleryCategory = val;
};

export const getGalleryIndex = (): number => _galleryIndex;
export const setGalleryIndex = (val: number): void => {
    _galleryIndex = val;
};

export const getGalleryStartTime = (): number => _galleryStartTime;
export const setGalleryStartTime = (val: number): void => {
    _galleryStartTime = val;
};

export const getGalleryLoadingTimer = (): number => _galleryLoadingTimer;
export const setGalleryLoadingTimer = (val: number): void => {
    _galleryLoadingTimer = val;
};

export const getGalleryShipPage = (): number => _galleryShipPage;
export const setGalleryShipPage = (val: number): void => {
    _galleryShipPage = val;
};

export const getTitleTimer = (): number => _titleTimer;
export const setTitleTimer = (val: number): void => {
    _titleTimer = val;
};

export const getDt = (): number => _dt;
export const setDt = (val: number): void => {
    _dt = val;
};
